/**
 * es locale — Spanish (Latin America, es-419)
 *
 * Extracted from all frontend source files (Issue #18 — i18n).
 * Falls back to pt-BR for any missing key.
 */
export const es: Record<string, string> = {
  // ---------------------------------------------------------------------------
  // common — shared strings used across multiple pages/components
  // ---------------------------------------------------------------------------
  'common.loading': 'Cargando...',
  'common.checkSpam': 'Si no lo recibe en unos minutos, revise la carpeta de spam o correo no deseado.',
  'common.checkSpamThirdParty': 'Si no lo reciben en unos minutos, pida que revisen la carpeta de spam o correo no deseado.',
  'common.close': 'Cerrar',
  'common.cancel': 'Cancelar',
  'common.filter': 'Filtrar',
  'common.from': 'Desde',
  'common.to': 'Hasta',
  'common.all': 'Todos',
  'common.type': 'Tipo',
  'common.status': 'Estado',
  'common.origin': 'Origen',
  'common.date': 'Fecha',
  'common.file': 'Archivo',
  'common.value': 'Valor',
  'common.confidence': 'Confianza',
  'common.source': 'Origen',
  'common.field': 'Campo',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.email': 'Correo',
  'common.processing': 'Procesando...',
  'common.error': 'Error',
  'common.dash': '—',
  'common.filterPlaceholder': 'Filtrar...',
  'common.importId': 'Import ID',
  'common.corrected': 'corregido',
  'common.errorPrefix': 'Error: ',

  // Document type labels
  'common.doctype.nfe': 'NF-e',
  'common.doctype.nfse': 'NFS-e',
  'common.doctype.nfcom': 'NFCom',
  'common.doctype.email': 'Correo',
  'common.doctype.zip': 'ZIP',
  'common.doctype.unknown': 'Desconocido',

  // Legal document labels
  'common.legal.terms': 'Términos de Uso',
  'common.legal.privacy': 'Política de Privacidad',
  'common.legal.cookies': 'Política de Cookies',
  'common.legal.termsShort': 'Términos',
  'common.legal.privacyShort': 'Privacidad',
  'common.legal.cookiesShort': 'Cookies',
  'common.legal.custodia': 'Términos de Custodia',
  'common.legal.back': 'Volver',

  // ---------------------------------------------------------------------------
  // app — App.tsx
  // ---------------------------------------------------------------------------
  'app.loading': 'Cargando...',

  // ---------------------------------------------------------------------------
  // home — Home.tsx
  // ---------------------------------------------------------------------------
  'home.title': 'Aura Nota',
  'home.subtitle': 'Herramienta de captura y extracción estructurada de facturas fiscales brasileñas (NFS-e, NF-e y telecom).',
  'home.card.upload.title': 'Carga',
  'home.card.upload.desc': 'Reciba PDFs, XMLs e imágenes de documentos.',
  'home.card.extraction.title': 'Extracción',
  'home.card.extraction.desc': 'OCR, XML y LLM para leer campos automáticamente.',
  'home.card.review.title': 'Revisión',
  'home.card.review.desc': 'Interfaz humana para validar y corregir datos.',
  'home.hero.title': 'Aura Nota — Captura y extraccion inteligente de facturas fiscales',
  'home.hero.subtitle': 'Automatiza la lectura de NFS-e, NFCom y recibos con IA. Extrae, valida y exporta campos fiscales en segundos.',
  'home.hero.cta.signup': 'Empezar gratis',
  'home.hero.cta.pricing': 'Ver planes',
  'home.features.title': 'Caracteristicas',
  'home.features.extraction.title': 'Extraccion Automatica',
  'home.features.extraction.desc': 'Campos fiscales extraidos en segundos con IA',
  'home.features.lgpd.title': 'Cumplimiento LGPD',
  'home.features.lgpd.desc': 'Servidor en la Unión Europea con DPA, cifrado en tránsito y en reposo, DSAR y consentimiento integrados',
  'home.features.multilayout.title': 'Multi-layout',
  'home.features.multilayout.desc': 'NFS-e, NFCom, recibos y mas',
  'home.features.export.title': 'Exportacion Estructurada',
  'home.features.export.desc': 'JSON, CSV e integracion con tu ERP',
  'home.pricing.teaser.title': 'Planes desde R$ 0',
  'home.pricing.teaser.desc': 'Comienza gratis y escala segun tu demanda. Sin tarjeta de credito.',
  'home.pricing.teaser.cta': 'Ver planes',
  'home.footer.login': 'Iniciar sesion',
  'home.footer.signup': 'Registro',
  'home.footer.pricing': 'Planes',
  'home.footer.dsar': 'DSAR',
  'home.footer.terms': 'Terminos',
  'home.footer.privacy': 'Privacidad',
  // Issue #594: secciones de la landing publica (visitante).
  'home.howItWorks.title': 'Cómo funciona',
  'home.howItWorks.step1.title': 'Envíe sus facturas',
  'home.howItWorks.step1.desc': 'Reenvíe los documentos a su correo dedicado de captura o cargue manualmente PDFs, XMLs e imágenes.',
  'home.howItWorks.step2.title': 'Extracción automática',
  'home.howItWorks.step2.desc': 'El XML se lee directamente; los PDFs e imágenes pasan por OCR e IA para extraer los campos fiscales.',
  'home.howItWorks.step3.title': 'Revise con seguridad',
  'home.howItWorks.step3.desc': 'Los campos con baja confianza van a la cola de revisión — cada corrección queda registrada en la pista de auditoría.',
  'home.howItWorks.step4.title': 'Exporte a su ERP',
  'home.howItWorks.step4.desc': 'Descargue los datos estructurados en JSON o CSV y envíelos a su sistema contable o a su contador.',
  'home.captures.title': 'Qué capturamos',
  'home.captures.nfse.title': 'NFS-e',
  'home.captures.nfse.desc': 'Facturas de servicios en PDF y XML de los más diversos layouts y proveedores municipales.',
  'home.captures.nfcom.title': 'NFCom / NFT (modelo 62)',
  'home.captures.nfcom.desc': 'Facturas de telecom con plantillas dedicadas para las principales operadoras y un layout genérico.',
  'home.captures.nfe.title': 'NF-e y NFC-e',
  'home.captures.nfe.desc': 'XMLs de facturas de mercadería y cupones electrónicos leídos directamente, sin OCR.',
  'home.captures.others.title': 'Recibos, ZIP y correo',
  'home.captures.others.desc': 'Recibos y documentos escaneados vía OCR/IA, además de adjuntos en archivos ZIP y correos (.eml).',
  'home.personas.title': 'Para quién es',
  'home.personas.company.title': 'Empresas',
  'home.personas.company.desc': 'El equipo financiero reenvía las facturas al correo de captura y exporta los datos listos para el ERP o el contador.',
  'home.personas.accounting.title': 'Firmas de contabilidad',
  'home.personas.accounting.desc': 'Plan Team con hasta 5 usuarios, perfil de contador y documentos separados por cliente.',
  'home.personas.dev.title': 'Desarrolladores',
  'home.personas.dev.desc': 'Integre la captura a su sistema por la API — disponible en el plan Enterprise, bajo consulta.',
  'home.diff.title': 'Diferenciales',
  'home.diff.dedup.title': 'Deduplicación automática',
  'home.diff.dedup.desc': 'La misma factura no entra dos veces: detectamos duplicados por el hash del archivo y por la clave de acceso de la NF.',
  'home.diff.audit.title': 'Pista de auditoría',
  'home.diff.audit.desc': 'Cada acción sobre un documento queda registrada — quién la hizo, cuándo y por qué (LGPD).',
  'home.faq.title': 'Preguntas frecuentes',
  'home.faq.q1': '¿Qué tipos de documento procesa Aura Nota?',
  'home.faq.a1': 'NFS-e (PDF y XML de varios layouts municipales), facturas NFCom/NFT modelo 62, NF-e y NFC-e en XML, recibos y otros PDFs o imágenes vía OCR. También se aceptan archivos ZIP y correos con adjuntos.',
  'home.faq.q2': '¿Cómo funciona la captura por correo dedicado?',
  'home.faq.a2': 'Cada organización recibe una dirección de captura exclusiva. Basta reenviar los correos con las facturas adjuntas — entran automáticamente en la cola de procesamiento.',
  'home.faq.q3': '¿Guardan los archivos originales?',
  'home.faq.a3': 'No. El archivo se procesa y se descarta; solo conservamos los datos extraídos y los metadatos durante el plazo de retención configurable de su organización (por defecto: 5 años).',
  'home.faq.q4': '¿Necesito tarjeta de crédito para empezar?',
  'home.faq.a4': 'No. El plan Free incluye 10 documentos por mes y no pide tarjeta. Mejore el plan cuando necesite más volumen o usuarios.',
  'home.faq.q5': '¿Puedo cancelar cuando quiera?',
  'home.faq.a5': 'Sí. La cancelación entra en vigor al final del período ya pagado — sin cobro inmediato y sin multa.',
  'home.faq.q6': '¿Dónde se alojan mis datos?',
  'home.faq.a6': 'En un servidor en la Unión Europea (Francia), bajo contrato de tratamiento de datos (DPA) y Cláusulas Contractuales Estándar, en conformidad con la LGPD. Los detalles están en la Política de Privacidad.',
  'home.pricing.teaser.ctaSignup': 'Crear cuenta gratis',

  // ---------------------------------------------------------------------------
  // login — Login.tsx
  // ---------------------------------------------------------------------------
  'login.title': 'Iniciar sesión',
  'login.subtitle': 'Acceda a su cuenta de Aura Nota.',
  'login.email': 'Correo',
  'login.password': 'Contraseña',
  'login.submit': 'Iniciar sesión',
  'login.submitting': 'Iniciando sesión...',
  'login.noAccount': '¿No tienes cuenta?',
  'login.signupLink': 'Regístrate',
  'login.error.auth': 'Error al autenticar.',
  'session.expired': 'Su sesión ha expirado. Por favor, inicie sesión de nuevo.',
  'session.loginAgain': 'Iniciar sesión de nuevo',

  // ---------------------------------------------------------------------------
  // layout — Layout.tsx
  // ---------------------------------------------------------------------------
  'layout.brand': 'Aura Nota',
  'layout.nav.home': 'Inicio',
  'layout.nav.upload': 'Carga',
  'layout.nav.documents': 'Documentos',
  'layout.nav.billing': 'Facturacion',
  'layout.nav.quota': 'Cuota',
  'layout.nav.subscription': 'Suscripción',
  'layout.nav.myAccount': 'Mi Cuenta',
  'layout.account': 'Cuenta',
  'layout.logout': 'Cerrar sesión',
  'layout.login': 'Iniciar sesión',
  'layout.footer.terms': 'Términos de Uso',
  'layout.footer.privacy': 'Política de Privacidad',
  'layout.footer.cookies': 'Política de Cookies',
  'layout.footer.tagline': 'Aura Nota · captura y extracción de facturas fiscales',

  // ---------------------------------------------------------------------------
  // consent — ConsentGate.tsx
  // ---------------------------------------------------------------------------
  'consent.title': 'Consentimiento LGPD',
  'consent.intro': 'Para continuar utilizando Aura Nota, debe aceptar la versión vigente ({version}) de los siguientes documentos legales:',
  'consent.acceptLabel': 'He leído y acepto los Términos de Uso, la Política de Privacidad y la Política de Cookies.',
  'consent.submit': 'Aceptar y continuar',
  'consent.submitting': 'Registrando...',
  'consent.error.check': 'Error al verificar consentimiento.',
  'consent.error.mustAccept': 'Debe aceptar los documentos legales para continuar.',
  'consent.error.register': 'Error al registrar consentimiento.',

  // ---------------------------------------------------------------------------
  // errorBoundary — ErrorBoundary.tsx
  // ---------------------------------------------------------------------------
  'errorBoundary.title': 'Algo salió mal',
  'errorBoundary.message': 'Ocurrió un error inesperado. Intente recargar la página.',
  'errorBoundary.reload': 'Recargar',

  // ---------------------------------------------------------------------------
  // account — Account.tsx
  // ---------------------------------------------------------------------------
  'account.title': 'Mi cuenta',
  'account.emailLabel': 'Correo:',
  'account.statusLabel': 'Estado:',
  'account.statusActive': 'Activo',
  'account.statusInactive': 'Inactivo',
  'account.historyTitle': 'Historial de consentimiento',
  'account.legalDocsIntro': 'Documentos legales vigentes: ',
  'account.loading': 'Cargando...',
  'account.error.load': 'Error al cargar historial.',
  'account.empty': 'Ningún consentimiento registrado.',
  'account.col.document': 'Documento',
  'account.col.version': 'Versión',
  'account.col.accepted': 'Aceptado',
  'account.col.date': 'Fecha',
  'account.col.ip': 'IP',
  // Edicion de datos personales ("Mis datos") + cambio de contrasena.
  'account.profile.title': 'Mis datos',
  'account.profile.name': 'Nombre',
  'account.profile.namePlaceholder': 'Tu nombre completo',
  'account.profile.nameRequired': 'Introduce un nombre válido.',
  'account.profile.language': 'Idioma',
  'account.profile.email': 'Correo electrónico',
  'account.profile.emailNote': 'Para cambiar el correo, contacta con el soporte/administrador.',
  'account.profile.save': 'Guardar',
  'account.profile.saving': 'Guardando...',
  'account.profile.saved': 'Datos actualizados correctamente.',
  'account.profile.error': 'Error al guardar los datos.',
  'account.password.title': 'Cambiar contraseña',
  'account.password.current': 'Contraseña actual',
  'account.password.new': 'Nueva contraseña',
  'account.password.confirm': 'Confirmar nueva contraseña',
  'account.password.hint': 'Mínimo 8 caracteres, con al menos 1 letra y 1 número.',
  'account.password.submit': 'Cambiar contraseña',
  'account.password.submitting': 'Cambiando...',
  'account.password.success': 'Contraseña cambiada correctamente.',
  'account.password.error': 'Error al cambiar la contraseña.',
  'account.password.mismatch': 'La confirmación no coincide con la nueva contraseña.',
  'account.password.tooShort': 'La nueva contraseña debe tener al menos 8 caracteres.',

  // ---------------------------------------------------------------------------
  // audit — Audit.tsx
  // ---------------------------------------------------------------------------
  'audit.title': 'Auditoría LGPD',
  'audit.subtitle': 'Registro de eventos de procesamiento, acceso y consentimiento.',
  'audit.exportCsv': 'Exportar CSV',
  'audit.exportJson': 'Exportar JSON',
  'audit.compliance.title': 'Conformidad LGPD',
  'audit.compliance.pii': 'PII anonimizado: nombres de archivo y hashes se almacenan sin datos personales directos',
  'audit.compliance.retention': 'Retención: los registros de auditoría son inmutables y se mantienen según la política de retención',
  'audit.compliance.dsar': 'DSAR: derechos del titular (acceso, eliminación, portabilidad) disponibles vía API',
  'audit.filter.eventType': 'Tipo de evento',
  'audit.filter.from': 'Desde',
  'audit.filter.to': 'Hasta',
  'audit.filter.all': 'Todos',
  'audit.filter.action.documentUpload': 'Carga de documento',
  'audit.filter.action.documentUploadDuplicate': 'Carga duplicada',
  'audit.filter.action.documentProcess': 'Procesamiento',
  'audit.filter.action.documentDelete': 'Eliminación',
  'audit.filter.action.consentAccepted': 'Consentimiento',
  'audit.filter.action.login': 'Inicio de sesión',
  'audit.filter.action.logout': 'Cierre de sesión',
  'audit.loading': 'Cargando...',
  'audit.error.load': 'Error al cargar auditoría.',
  'audit.empty': 'Ningún evento de auditoría encontrado.',
  'audit.eventCount': '{count} eventos',
  'audit.col.date': 'Fecha',
  'audit.col.event': 'Evento',
  'audit.col.resource': 'Recurso',
  'audit.col.details': 'Detalles',
  'audit.col.user': 'Usuario',
  // Action labels (display in table)
  'audit.action.document_upload': 'Carga de documento',
  'audit.action.document_upload_duplicate': 'Carga duplicada',
  'audit.action.document_process': 'Procesamiento',
  'audit.action.document_delete': 'Eliminación de documento',
  'audit.action.consent_accepted': 'Consentimiento aceptado',
  'audit.action.login': 'Inicio de sesión',
  'audit.action.logout': 'Cierre de sesión',

  // ---------------------------------------------------------------------------
  // documents — Documents.tsx
  // ---------------------------------------------------------------------------
  'documents.title': 'Documentos',
  'documents.view.grid': 'Cuadrícula',
  'documents.view.cards': 'Tarjetas',
  'documents.export.csv': 'Exportar CSV',
  'documents.export.excel': 'Exportar Excel',
  'documents.filter.type': 'Tipo',
  'documents.filter.status': 'Estado',
  'documents.filter.all': 'Todos',
  'documents.filter.from': 'Desde',
  'documents.filter.to': 'Hasta',
  'documents.filter.importId': 'Import ID',
  'documents.filter.importIdPlaceholder': 'ej: 20260819-001',
  'documents.filter.button': 'Filtrar',
  'documents.loading': 'Cargando...',
  'documents.loadingDetails': 'Cargando detalles...',
  'documents.empty': 'Ningún documento encontrado.',
  'documents.error.load': 'Error al cargar documentos.',
  'documents.error.loadDetail': 'Error al cargar detalle.',
  'documents.error.saveField': 'Error al guardar campo.',
  'documents.error.export': 'Error al exportar.',

  // Status filter options
  'documents.status.concluido': 'Completado',
  'documents.status.revisao': 'Revisión',
  'documents.status.erro': 'Error',
  'documents.status.recebido': 'Recibido',

  // Fiscal column headers (grid)
  'documents.col.numero': 'Número',
  'documents.col.serie': 'Serie',
  'documents.col.prestadorCnpj': 'Prestador CNPJ',
  'documents.col.prestadorCnpjEmitente': 'CNPJ del Emisor',
  'documents.col.prestador': 'Prestador',
  'documents.col.tomadorCnpj': 'Tomador CNPJ',
  'documents.col.tomadorCnpjDestinatario': 'CNPJ del Destinatario',
  'documents.col.tomador': 'Tomador',
  'documents.col.valorTotal': 'Valor Total',
  'documents.col.valorServico': 'Valor Servicio',
  'documents.col.dataEmissao': 'Fecha Emisión',
  'documents.col.municipio': 'Municipio',
  'documents.col.codVerificacao': 'Cód. Verificación',
  'documents.col.descricao': 'Descripción',
  'documents.col.imPrestador': 'IM Prestador',
  'documents.col.docType': 'Tipo de Documento',
  'documents.col.importId': 'Import ID',
  'documents.col.origin': 'Origen',

  // Cards view headers
  'documents.cards.importId': 'Import ID',
  'documents.cards.file': 'Archivo',
  'documents.cards.type': 'Tipo',
  'documents.cards.status': 'Estado',
  'documents.cards.fields': 'Campos',
  'documents.cards.confidence': 'Confianza',
  'documents.cards.children': 'Hijos',
  'documents.cards.date': 'Enviado',

  // Detail panel
  'documents.detail.close': 'Cerrar',
  'documents.detail.downloading': 'Descargando...',
  'documents.detail.downloadJson': 'Descargar JSON',
  'documents.detail.downloadXml': 'Descargar XML',
  'documents.detail.downloadPdf': 'Descargar PDF',
  'documents.detail.downloadFields': 'Descargar campos (CSV)',
  'documents.detail.type': 'Tipo',
  'documents.detail.origin': 'Origen',
  'documents.detail.status': 'Estado',
  'documents.detail.avgConfidence': 'Confianza promedio',
  'documents.detail.importId': 'ID de importación',
  'documents.detail.needsReview': 'Requiere revisión: {reason}',
  'documents.detail.reviewReasonDefault': 'Motivo no especificado',
  'documents.detail.error': 'Error: {error}',
  'documents.detail.extractedFields': 'Campos extraídos',
  'documents.detail.col.field': 'Campo',
  'documents.detail.col.value': 'Valor',
  'documents.detail.col.confidence': 'Confianza',
  'documents.detail.col.origin': 'Origen',
  'documents.detail.col.raw': 'Raw',
  'documents.detail.metadata': 'Metadatos',
  'documents.detail.children': 'Documentos hijos ({count})',
  'documents.detail.childError': 'error',
  'documents.detail.processingLog': 'Registro de auditoría del procesamiento',

  // Editable cell tooltip
  'documents.cell.tooltip': '{field} — confianza {conf}% (doble clic para editar)',

  // Provenance modal
  'documents.provenance.title': 'Cadena de Origen',
  'documents.provenance.close': 'Cerrar',
  'documents.provenance.noChain': 'Sin container_chain (archivo terminal directo).',
  'documents.delete': 'Eliminar',
  'documents.deleteConfirm': 'Seguro que desea mover este documento a la papelera? Podra recuperarlo durante 30 dias.',
  'documents.trash': 'Papelera',
  'documents.restore': 'Restaurar',
  'documents.daysUntilPurge': 'Dias hasta eliminacion permanente',
  'documents.timeRemaining': 'Tiempo restante: {days} dias hasta eliminacion permanente',
  'documents.trashEmpty': 'La papelera esta vacia.',
  'documents.trashDeletedAt': 'Eliminado el',
  'documents.actions': 'Acciones',
  'documents.error.delete': 'Error al mover documento a la papelera.',
  'documents.error.restore': 'Error al restaurar documento.',

  // Batch selection (Feature 2)
  'documents.batch.selectedCount': '{count} seleccionados',
  'documents.batch.selectAll': 'Seleccionar todos',
  'documents.batch.deleteTitle': 'Eliminar documentos',
  'documents.batch.deleteConfirm': '¿Está seguro de que desea eliminar {count} documento(s)? Se moverán a la papelera y podrán recuperarse durante 30 días.',
  'documents.batch.deletePartialError': 'Error al eliminar {failed} de {total} documento(s).',

  // ---------------------------------------------------------------------------
  // upload — Upload.tsx
  // ---------------------------------------------------------------------------
  'upload.title': 'Carga de Documentos',
  'upload.subtitle': 'Envíe PDFs, XMLs, correos (.eml/.msg), ZIPs, HTML o imágenes para extracción automática de campos fiscales.',
  'upload.dropzone.text': 'Arrastre archivos aquí o haga clic para seleccionar',
  'upload.dropzone.formats': 'Formatos: {formats} — Máx 25 MB',
  'upload.process': 'Procesar ({count} pendientes)',
  'upload.processing': 'Procesando...',
  'upload.clear': 'Limpiar',
  'upload.summary': '{done} completados, {errors} errores, {pending} pendientes',
  'upload.filesTitle': 'Archivos enviados',
  'upload.viewResult': 'Ver resultado',
  'upload.remove': 'Remover',
  'upload.result.type': 'Tipo: {type}',
  'upload.result.origin': 'Origen: {origin}',
  'upload.result.fields': 'Campos: {count}',
  'upload.result.errors': 'Errores: {count}',
  'upload.result.duplicate': 'Duplicado',
  'upload.error.batchNotFound': 'Resultado no encontrado en el lote.',
  'upload.error.cancelledDuplicate': 'Cancelado (duplicado no procesado)',
  'upload.error.timeout': 'Se agotó el tiempo de espera del procesamiento.',
  // Issue #279: Modo por lotes para subidas de 3+ archivos.
  'upload.batch.submitted': 'Lote enviado. Se le notificará al completarse.',
  'upload.batch.inProgress': 'Lote en proceso: {done}/{total} completados',
  'upload.batch.complete': 'Lote completado: {success} éxitos, {errors} errores',
  'upload.batch.blocked': 'Espere a que termine el lote actual',
  'upload.batch.networkError': 'El lote puede estar procesándose en el servidor. Verifique la lista de documentos antes de reenviar.',
  'upload.batch.checkStatus': 'Verificar estado',

  // Status badge labels
  'upload.status.pending': 'Pendiente',
  'upload.status.uploading': 'Enviando...',
  'upload.status.processing': 'Procesando...',
  'upload.status.done': 'Completado',
  'upload.status.error': 'Error',

  // Result panel
  'upload.result.title': 'Resultado de extracción',
  'upload.result.close': 'Cerrar',
  'upload.result.file': 'Archivo',
  'upload.result.typeLabel': 'Tipo',
  'upload.result.originLabel': 'Origen',
  'upload.result.time': 'Tiempo',
  'upload.result.needsReview': 'Requiere revisión: {reason}',
  'upload.result.reviewReasonDefault': 'Motivo no especificado',
  'upload.result.error': 'Error: {error}',
  'upload.result.extractedFields': 'Campos extraídos',
  'upload.result.col.field': 'Campo',
  'upload.result.col.value': 'Valor',
  'upload.result.col.confidence': 'Confianza',
  'upload.result.col.origin': 'Origen',
  'upload.result.metadata': 'Metadatos',
  'upload.result.children': 'Documentos hijos ({count})',
  'upload.result.childError': 'error',

  // Duplicate modal (single file)
  'upload.duplicate.title': 'NF Duplicada Detectada',
  'upload.duplicate.intro': 'Esta NF ya fue procesada anteriormente.',
  'upload.duplicate.type.file': 'Archivo idéntico',
  'upload.duplicate.type.data': 'Misma NF (datos)',
  'upload.duplicate.importId': 'Import ID',
  'upload.duplicate.type': 'Tipo',
  'upload.duplicate.file': 'Archivo',
  'upload.duplicate.processedAt': 'Procesada el',
  'upload.duplicate.whatToDo': '¿Qué desea hacer?',
  'upload.duplicate.replace': 'Reemplazar',
  'upload.duplicate.replaceDesc': 'elimina el registro anterior y crea uno nuevo',
  'upload.duplicate.archive': 'Archivar',
  'upload.duplicate.archiveDesc': 'mantiene el registro anterior archivado y crea uno nuevo',
  'upload.duplicate.duplicate': 'Duplicar',
  'upload.duplicate.duplicateDesc': 'crea un nuevo registro sin alterar el anterior',
  'upload.duplicate.cancel': 'Cancelar',
  'upload.duplicate.cancelDesc': 'no procesar',
  'upload.duplicate.processing': 'Procesando...',

  // Batch duplicate modal
  'upload.batchDuplicate.title': '{count} archivo(s) duplicado(s) encontrado(s)',
  'upload.batchDuplicate.intro': 'Los archivos siguientes ya fueron procesados anteriormente. Elija una acción para cada uno. Los archivos no duplicados se procesarán normalmente.',
  'upload.batchDuplicate.type.file': 'Archivo idéntico',
  'upload.batchDuplicate.type.data': 'Misma NF (datos)',
  'upload.batchDuplicate.existingImportId': 'Import ID existente',
  'upload.batchDuplicate.existingFile': 'Archivo existente',
  'upload.batchDuplicate.processedAt': 'Procesado el',
  'upload.batchDuplicate.replace': 'Reemplazar',
  'upload.batchDuplicate.replaceDesc': 'elimina el anterior y crea nuevo',
  'upload.batchDuplicate.archive': 'Archivar',
  'upload.batchDuplicate.archiveDesc': 'archiva el anterior y crea nuevo',
  'upload.batchDuplicate.duplicate': 'Duplicar',
  'upload.batchDuplicate.duplicateDesc': 'crea nuevo sin alterar el anterior',
  'upload.batchDuplicate.remove': 'Remover',
  'upload.batchDuplicate.removeDesc': 'elimina el registro anterior (admin)',
  'upload.batchDuplicate.cancel': 'Cancelar',
  'upload.batchDuplicate.cancelDesc': 'no procesar',
  'upload.batchDuplicate.cancelAll': 'Cancelar todo',
  'upload.batchDuplicate.confirm': 'Confirmar decisiones',
  'upload.batchDuplicate.processing': 'Procesando...',

  // Notifications (Issue #281)
  'notifications.title': 'Notificaciones',
  'notifications.empty': 'Sin notificaciones',
  'notifications.markAllRead': 'Marcar todas como leídas',
  'notifications.batchComplete': 'Lote completado',
  'notifications.justNow': 'justo ahora',
  'notifications.minutesAgo': 'hace {n} min',
  'notifications.hoursAgo': 'hace {n} h',
  'notifications.daysAgo': 'hace {n} d',
  // Sprint 7: Billing / Pricing / Signup

  'layout.nav.pricing': 'Planes',
  'pricing.title': 'Elija el plan ideal para usted',
  'pricing.subtitle': 'Comience gratis y evolucione según su demanda. Sin tarjeta de crédito.',
  'pricing.unlimited': 'Contáctenos',
  'pricing.free': 'Gratis',
  'pricing.month': 'mes',
  'pricing.unlimitedDocs': 'Documentos ilimitados',
  'pricing.docsPerMonth': '{count} documentos/mes',
  'pricing.popular': 'Más popular',
  'pricing.feat.upload': 'Carga de documentos',
  'pricing.feat.exportCsv': 'Exportar CSV',
  'pricing.feat.multiUser': 'Múltiples usuarios',
  'pricing.feat.audit': 'Auditoría',
  'pricing.feat.apiAccess': 'Acceso a API',
  'pricing.feat.prioritySupport': 'Soporte prioritario',
  'pricing.ctaFree': 'Empezar gratis',
  'pricing.ctaPaid': 'Suscribirse',
  'pricing.processing': 'Procesando...',
  'pricing.pixTitle': 'Pagar vía PIX',
  'pricing.pixInstructions': 'Escanee el código QR a continuación con su banco para pagar la suscripción.',
  'pricing.goToBilling': 'Ir a Billing',
  // Issue #593: planes Single/Team/Enterprise (contrato #592) + tabla
  // comparativa en la misma pagina.
  'pricing.ctaEnterprise': 'Hablar con ventas',
  'pricing.enterpriseMailSubject': 'Aura Nota — Plan Enterprise',
  'pricing.users.one': '1 usuario',
  'pricing.users.upTo': 'Hasta {count} usuarios',
  'pricing.users.unlimited': 'Usuarios ilimitados',
  'pricing.feat.exportJson': 'Exportar JSON',
  'pricing.feat.emailCapture': 'Captura por correo dedicado',
  'pricing.feat.accountant': 'Usuario contador',
  'pricing.feat.onboarding': 'Onboarding asistido',
  'comparison.title': 'Comparación de planes',
  'comparison.subtitle': 'Todos los recursos, lado a lado.',
  'comparison.feature': 'Recurso',
  'comparison.unlimited': 'Ilimitado',
  'comparison.row.docs': 'Documentos por mes',
  'comparison.row.users': 'Usuarios incluidos',
  'comparison.row.accountant': 'Usuario contador',
  'comparison.row.emailUpload': 'Captura por correo dedicado y carga manual',
  'comparison.row.exportJson': 'Exportación JSON',
  'comparison.row.exportCsv': 'Exportación CSV',
  'comparison.row.multiUser': 'Multiusuario (equipo)',
  'comparison.row.audit': 'Pista de auditoría (LGPD)',
  'comparison.row.apiAccess': 'Acceso a API',
  'comparison.row.prioritySupport': 'Soporte prioritario',
  'comparison.row.onboarding': 'Onboarding asistido',
  'signup.title': 'Crear cuenta',
  'signup.subtitle': 'Comience a usar Aura Nota gratis.',
  'signup.name': 'Nombre',
  'signup.company': 'Empresa',
  'signup.email': 'Correo electrónico',
  'signup.password': 'Contraseña',
  'signup.passwordHint': 'Mínimo 8 caracteres, 1 letra y 1 número.',
  'signup.submit': 'Crear cuenta',
  'signup.submitting': 'Creando...',
  'signup.error': 'No se pudo crear la cuenta.',
  'signup.haveAccount': '¿Ya tiene cuenta?',
  'signup.loginLink': 'Iniciar sesión',
  'signup.successTitle': '¡Cuenta creada!',
  'signup.successBody': 'Revise su correo para activar la cuenta. Después de la activación, podrá iniciar sesión.',
  'signup.goLogin': 'Ir a login',
  'billing.title': 'Billing',
  'billing.currentPlan': 'Plan actual',
  'billing.planLabel': 'Plan',
  'billing.statusLabel': 'Estado',
  'billing.status.active': 'Activo',
  'billing.status.pending_payment': 'Pago pendiente',
  'billing.status.suspended': 'Suspendido',
  'billing.status.cancelled': 'Cancelado',
  'billing.renewsOn': 'Se renueva el',
  'billing.paymentMethod': 'Método de pago',
  'billing.usage': 'Uso este mes',
  'billing.used': '{used} de {limit} documentos',
  'billing.remaining': '{count} restantes',
  'billing.unlimited': 'Ilimitado',
  'billing.resetsOn': 'Se reinicia el {date}',
  'billing.pendingPayment': 'Pago pendiente',
  'billing.invoiceAmount': 'R$ {amount}',
  'billing.dueDate': 'Vencimiento: {date}',
  'billing.pixTitle': 'Pagar vía PIX',
  'billing.pixInstructions': 'Escanee el código QR con su banco. Después del pago, un admin confirmará y su plan se activará.',
  'billing.invoiceId': 'Factura: {id}',
  'billing.refresh': 'Actualizar',
  'billing.upgradePro': 'Mejorar a Pro',
  'billing.viewPlans': 'Ver planes y mejorar',
  'billing.cancel': 'Cancelar suscripción',
  'billing.cancelConfirm': '¿Está seguro de que desea cancelar su suscripción?',
  'billing.processing': 'Procesando...',
  'signup.consentPrefix': 'He leído y acepto los',
  'signup.consentAnd': 'y la',
  'signup.consentRequired': 'Debe aceptar los Términos de Uso y la Política de Privacidad para crear la cuenta.',

  'layout.nav.sefaz': 'Buscar por Clave',
  'sefaz.title': 'Buscar NF-e por Clave de Acceso',
  'sefaz.tab.individual': 'Individual',
  'sefaz.tab.batch': 'Lote (Excel)',
  'sefaz.individual.label': 'Clave de Acceso (44 dígitos)',
  'sefaz.individual.invalid': 'Clave inválida: debe tener 44 dígitos con dígito verificador válido',
  'sefaz.individual.valid': 'Clave válida',
  'sefaz.individual.search': 'Buscar',
  'sefaz.individual.result': 'Resultado de la búsqueda',
  'sefaz.individual.goToDocs': 'Ver documento en Documentos',
  'sefaz.status': 'Estado',
  'sefaz.batch.downloadTemplate': 'Descargar Plantilla Excel',
  'sefaz.batch.dropHere': 'Arrastre un archivo .xlsx aquí o haga clic para seleccionar',
  'sefaz.batch.errorFormat': 'El archivo debe ser .xlsx',
  'sefaz.batch.progress': 'Progreso del lote',
  'sefaz.batch.total': 'Total',
  'sefaz.batch.processed': 'Procesadas',
  'sefaz.batch.success': 'Éxito',
  'sefaz.batch.error': 'Errores',
  'sefaz.batch.status': 'Estado',
  'sefaz.batch.goToDocs': 'Ver documentos creados',
  'sefaz.batch.history': 'Lotes anteriores',
  'sefaz.batch.export': 'Exportar resultados',
  'layout.nav.sefazGroup': 'Fiscal / SEFAZ',
  'sefaz.nav.status': 'Estado del servicio',
  'sefaz.nav.consulta': 'Consulta por clave',
  'sefaz.nav.dfe': 'Distribución DF-e por NSU',
  'sefaz.nav.certs': 'Certificados',
  'sefaz.statusPage.title': 'Estado del servicio SEFAZ',
  'sefaz.statusPage.ufLabel': 'UF',
  'sefaz.statusPage.tab.nfe': 'NF-e',
  'sefaz.statusPage.tab.cte': 'CT-e',
  'sefaz.statusPage.tab.mdfe': 'MDF-e',
  'sefaz.statusPage.consult': 'Consultar',
  'sefaz.statusPage.cstat': 'cStat',
  'sefaz.statusPage.xmotivo': 'Motivo',
  'sefaz.statusPage.uf': 'UF',
  'sefaz.statusPage.timestamp': 'Fecha/hora',
  'sefaz.statusPage.rateLimited': 'Límite de solicitudes excedido. Intente de nuevo en {s}s.',
  'sefaz.statusPage.unavailable': 'El servicio SEFAZ no está disponible en este momento. Intente de nuevo en breve.',
  'sefaz.gated.title': 'Requiere un certificado A1 configurado',
  'sefaz.gated.body': 'Esta consulta requiere un certificado digital A1 vinculado a la organización. Regístrelo en Fiscal/SEFAZ > Certificados.',
  'sefaz.gated.cta': 'Ir a Certificados',
  'sefaz.dfe.title': 'Distribución DF-e por NSU',
  'sefaz.dfe.nsuLabel': 'Último NSU (15 dígitos)',
  'sefaz.certs.title': 'Gestión de certificados A1',
  'sefaz.certs.badge': 'Próximamente',
  'sefaz.certs.body': 'Aquí podrá registrar y gestionar el certificado digital A1 de la organización, necesario para las consultas autenticadas a SEFAZ (consulta por clave y distribución DF-e).',
  // Sprint 14 (issue #482): pagina real de custodia de certificados A1.
  'sefaz.certs.subtitle': 'Certificado digital A1 (e-CNPJ) utilizado en las consultas autenticadas a SEFAZ.',
  'sefaz.certs.retry': 'Reintentar',
  'sefaz.certs.tab.detail': 'Certificado',
  'sefaz.certs.tab.history': 'Historial',
  'sefaz.certs.empty.title': 'Ningún certificado registrado',
  'sefaz.certs.empty.body': 'Envíe el certificado digital A1 (.pfx/.p12) de la organización para habilitar las consultas autenticadas a SEFAZ.',
  'sefaz.certs.empty.memberHint': 'La organización aún no tiene certificado digital registrado. Pida a un administrador que lo envíe.',
  'sefaz.certs.empty.cta': 'Enviar certificado',
  'sefaz.certs.member.title': 'Certificado digital de la organización',
  'sefaz.certs.member.absent': 'Ningún certificado digital registrado.',
  'sefaz.certs.member.configured': 'Certificado digital configurado y activo.',
  'sefaz.certs.member.expiring': 'El certificado digital vence en {n} día(s).',
  'sefaz.certs.member.expired': 'El certificado digital está vencido.',
  'sefaz.certs.member.hint': 'La gestión del certificado está restringida a los administradores de la organización.',
  'sefaz.certs.expiredBanner': 'El certificado digital está vencido — las consultas a SEFAZ están indisponibles hasta la rotación.',
  'sefaz.certs.expiredCta': 'Rotar ahora',
  'sefaz.certs.meta.title': 'Certificado en custodia',
  'sefaz.certs.meta.cn': 'Nombre (CN)',
  'sefaz.certs.meta.issuer': 'Emisor',
  'sefaz.certs.meta.serial': 'Número de serie',
  'sefaz.certs.meta.cnpj': 'CNPJ',
  'sefaz.certs.meta.validFrom': 'Válido desde',
  'sefaz.certs.meta.validTo': 'Válido hasta',
  'sefaz.certs.meta.fingerprint': 'Fingerprint SHA-256',
  'sefaz.certs.meta.uploadedAt': 'Enviado el',
  'sefaz.certs.meta.uploadedBy': 'Enviado por',
  'sefaz.certs.meta.lastSession': 'Última sesión MCP',
  'sefaz.certs.status.ativo': 'Activo',
  'sefaz.certs.status.ausente': 'Sin certificado',
  'sefaz.certs.status.vencendo': 'Vence en {n} días',
  'sefaz.certs.status.expirado': 'Vencido',
  'sefaz.certs.status.pendente': 'Pendiente de consentimiento',
  'sefaz.certs.status.removido': 'Eliminado',
  'sefaz.certs.actions.rotate': 'Rotar certificado',
  'sefaz.certs.actions.remove': 'Eliminar certificado',
  'sefaz.certs.upload.titleCreate': 'Enviar certificado A1',
  'sefaz.certs.upload.titleRotate': 'Rotar certificado A1',
  'sefaz.certs.upload.dropzone': 'Arrastre el archivo del certificado aquí o haga clic para seleccionar',
  'sefaz.certs.upload.formats': 'Formatos aceptados: .pfx o .p12 — máximo 64 KB',
  'sefaz.certs.upload.changeFile': 'haga clic para cambiar el archivo',
  'sefaz.certs.upload.fileErrorExt': 'Archivo inválido: envíe un certificado .pfx o .p12 (A1).',
  'sefaz.certs.upload.fileErrorSize': 'El archivo excede el límite de 64 KB.',
  'sefaz.certs.upload.passwordLabel': 'Contraseña del certificado',
  'sefaz.certs.upload.passwordHint': 'La contraseña solo se usa para validar el certificado y se almacena cifrada — nunca se muestra ni se guarda en el navegador.',
  'sefaz.certs.upload.submitCreate': 'Validar y custodiar',
  'sefaz.certs.upload.submitRotate': 'Validar y rotar',
  'sefaz.certs.upload.successCreate': 'Certificado enviado y custodiado con éxito.',
  'sefaz.certs.upload.successRotate': 'Certificado rotado con éxito.',
  'sefaz.certs.consent.text': 'Autorizo a Aura Nota a custodiar el certificado digital A1 de la organización (CNPJ {cnpj}) de forma cifrada, usarlo exclusivamente para consultas fiscales en mi nombre mediante sesiones transitorias, y reconozco que puedo revocar esta autorización y eliminar el certificado en cualquier momento.',
  'sefaz.certs.consent.textNoCnpj': 'Autorizo a Aura Nota a custodiar el certificado digital A1 de la organización de forma cifrada, usarlo exclusivamente para consultas fiscales en mi nombre mediante sesiones transitorias, y reconozco que puedo revocar esta autorización y eliminar el certificado en cualquier momento.',
  'sefaz.certs.consent.linkLabel': 'Leer el término de custodia',
  'sefaz.certs.mismatch.title': 'CNPJ divergente',
  'sefaz.certs.mismatch.body': 'El CNPJ del nuevo certificado no coincide con el CNPJ de la organización. Solo confirme si la organización realmente cambió de CNPJ o si este certificado pertenece al titular correcto.',
  'sefaz.certs.mismatch.confirm': 'Confirmar divergencia y rotar',
  'sefaz.certs.remove.title': 'Eliminar certificado',
  'sefaz.certs.remove.impact': 'Impacto: las consultas fiscales (SEFAZ/RFB) de esta organización quedan indisponibles hasta el envío de un nuevo certificado. El material cifrado se borra inmediatamente y la sesión MCP se cierra.',
  'sefaz.certs.remove.confirmLabel': 'Entiendo el impacto y confirmo la eliminación del certificado en custodia.',
  'sefaz.certs.remove.confirm': 'Eliminar definitivamente',
  'sefaz.certs.remove.success': 'Certificado eliminado de la custodia.',
  'sefaz.certs.history.col.action': 'Acción',
  'sefaz.certs.history.col.user': 'Usuario',
  'sefaz.certs.history.col.timestamp': 'Fecha/hora',
  'sefaz.certs.history.col.ip': 'IP',
  'sefaz.certs.history.empty': 'Ningún evento registrado para este certificado.',
  'sefaz.certs.history.prev': 'Anterior',
  'sefaz.certs.history.next': 'Siguiente',
  'sefaz.certs.history.page': 'Página {page} de {pages}',
  'sefaz.certs.history.action.cert_upload': 'Envío de certificado',
  'sefaz.certs.history.action.cert_view': 'Visualización de metadatos',
  'sefaz.certs.history.action.cert_rotate': 'Rotación de certificado',
  'sefaz.certs.history.action.cert_delete': 'Eliminación de certificado',
  'sefaz.certs.history.action.cert_use': 'Uso en consulta SEFAZ',
  'sefaz.certs.history.action.cert_consent_grant': 'Consentimiento registrado',
  'sefaz.certs.history.action.cert_consent_revoke': 'Consentimiento revocado',
  'sefaz.certs.history.action.cert_session_open': 'Sesión MCP abierta',
  'sefaz.certs.error.invalidPfx': 'Contraseña del certificado incorrecta o archivo inválido.',
  'sefaz.certs.error.invalidChain': 'El certificado no es A1 ICP-Brasil (e-CPF, A3 o autofirmados no son aceptados).',
  'sefaz.certs.error.expired': 'Certificado vencido — envíe un certificado válido.',
  'sefaz.certs.error.cnpjMismatch': 'El CNPJ del certificado no coincide con el CNPJ de la organización.',
  'sefaz.certs.error.rateLimited': 'Límite de intentos excedido. Reintente en {min} min.',
  'sefaz.certs.error.uploadDisabled': 'El envío de certificados está deshabilitado en este entorno.',
  'sefaz.certs.error.noOrgCnpj': 'Registre el CNPJ de la organización antes de enviar el certificado.',
  'sefaz.certs.error.pfxTooLarge': 'El archivo del certificado excede el límite aceptado.',
  'sefaz.certs.error.alreadyExists': 'Ya existe un certificado en custodia — use la rotación para reemplazarlo.',
  'sefaz.certs.error.consentRequired': 'Es necesario aceptar el término de custodia para continuar.',
  'sefaz.certs.error.confirmRequired': 'Confirme la operación para continuar.',
  'sefaz.certs.error.unavailable': 'Servicio de consulta fiscal indisponible. Reintente en unos instantes.',
  'sefaz.certs.error.forbidden': 'No tiene permiso para esta acción.',
  'sefaz.certs.error.validation': 'Datos del certificado inválidos.',
  'sefaz.certs.error.generic': 'No fue posible completar la operación.',

  // catalogo — catálogo colaborativo de municipios/proveedores (S10-T06)
  'layout.nav.catalogo': 'Municipios',
  'catalogo.title': 'Catálogo de Municipios',
  'catalogo.subtitle': 'Mapeo colaborativo municipio → proveedor NFS-e.',
  'catalogo.stats.municipios': 'Municipios cubiertos',
  'catalogo.stats.provedores': 'Proveedores soportados',
  'catalogo.stats.ufs': 'Estados cubiertos',
  'catalogo.stats.pendentes': 'Sugerencias pendientes',
  'catalogo.table.title': 'Municipios',
  'catalogo.table.ibge': 'IBGE',
  'catalogo.table.nome': 'Municipio',
  'catalogo.table.uf': 'Estado',
  'catalogo.table.provedor': 'Proveedor',
  'catalogo.table.agregador': 'Agregador',
  'catalogo.table.empty': 'No se encontraron municipios.',
  'catalogo.filter.uf': 'Estado',
  'catalogo.filter.provedor': 'Proveedor',
  'catalogo.filter.busca': 'Buscar municipio',
  'catalogo.export': 'Exportar JSON',
  'catalogo.import': 'Importar JSON',
  'catalogo.import.result': 'Importación: {created} creados, {updated} actualizados ({total} ítems).',
  'catalogo.suggest.title': 'Sugerir mapeo',
  'catalogo.suggest.ibge': 'Código IBGE',
  'catalogo.suggest.nome': 'Municipio',
  'catalogo.suggest.uf': 'Estado',
  'catalogo.suggest.provedor': 'Proveedor',
  'catalogo.suggest.agregador': 'Agregador (opcional)',
  'catalogo.suggest.justificativa': 'Justificación (opcional)',
  'catalogo.suggest.submit': 'Enviar sugerencia',
  'catalogo.suggest.success': 'Sugerencia enviada a moderación.',
  'catalogo.sugestoes.title': 'Sugerencias',
  'catalogo.sugestoes.empty': 'Sin sugerencias.',
  'catalogo.sugestoes.status.pendente': 'Pendiente',
  'catalogo.sugestoes.status.aprovada': 'Aprobada',
  'catalogo.sugestoes.status.rejeitada': 'Rechazada',
  'catalogo.moderation.actions': 'Acciones',
  'catalogo.moderation.approve': 'Aprobar',
  'catalogo.moderation.reject': 'Rechazar',
  'catalogo.moderation.rejectPrompt': 'Motivo del rechazo (opcional):',
  'catalogo.history.title': 'Historial del catálogo',
  'catalogo.history.action': 'Acción',
  'catalogo.history.action.create': 'Creación',
  'catalogo.history.action.update': 'Actualización',
  'catalogo.history.action.delete': 'Eliminación',
  'catalogo.history.origem.admin': 'Edición directa',
  'catalogo.history.origem.sugestao': 'Sugerencia aprobada',
  'catalogo.history.origem.import': 'Importación',
  'catalogo.history.empty': 'Sin cambios registrados.',
  'catalogo.error.generic': 'No fue posible completar la operación.',

  // ---------------------------------------------------------------------------
  // onboarding — asistente guiado del tenant (S10-T07, US-S10-007)
  // ---------------------------------------------------------------------------
  'layout.nav.onboarding': 'Onboarding',
  'onboarding.title': 'Onboarding asistido',
  'onboarding.subtitle': 'Configure la organización paso a paso: correo, municipios, thresholds y un tour por la interfaz.',
  'onboarding.progress': '{done} de {total} etapas',
  'onboarding.error.load': 'Error al cargar el checklist de onboarding.',
  'onboarding.error.action': 'Error al ejecutar la acción.',
  'onboarding.step.email': 'Correo electrónico',
  'onboarding.step.municipios': 'Municipios',
  'onboarding.step.thresholds': 'Umbrales',
  'onboarding.step.tour': 'Tour guiado',
  'onboarding.step.auto': 'detectado',
  'onboarding.step.autoHint': 'Etapa ya satisfecha por la configuración actual de la organización.',
  'onboarding.step.complete': 'Completar etapa',
  'onboarding.step.completeHint': 'La etapa solo puede completarse cuando la configuración correspondiente ya está guardada.',
  'onboarding.step.done': 'Etapa completada',
  'onboarding.nav.prev': 'Volver',
  'onboarding.nav.next': 'Siguiente',
  'onboarding.finish': 'Finalizar onboarding',
  'onboarding.help.title': 'Ayuda',
  'onboarding.help.email': 'Configure un buzón IMAP para la captura automática de notas y/o el SMTP de envío. Después del onboarding, gestione todo en Configuración → Correo.',
  'onboarding.help.municipios': 'Seleccione los municipios cuyas NFS-e recibe su organización. La selección viene del catálogo colaborativo municipio → proveedor.',
  'onboarding.help.thresholds': 'Defina los umbrales de validación de la extracción. Puede ajustarlos después en Configuración → Umbrales.',
  'onboarding.help.tour': 'El tour muestra las principales áreas de la interfaz. Puede saltarlo y completar la etapa manualmente.',
  'onboarding.help.link.settingsEmail': 'Abrir Configuración',
  'onboarding.help.link.settingsThresholds': 'Abrir Configuración',
  'onboarding.help.link.catalogo': 'Abrir catálogo de municipios',
  'onboarding.email.title': 'Correo (captura y envío)',
  'onboarding.email.subtitle': 'Configure el buzón IMAP monitorizado y/o el servidor SMTP de la organización, con prueba de conexión.',
  'onboarding.email.imapDetected': 'IMAP configurado',
  'onboarding.email.smtpDetected': 'SMTP configurado',
  'onboarding.email.imapLegend': 'IMAP — captura de notas',
  'onboarding.email.imapHint': 'Buzón monitorizado para la captura automática de NFS-e/facturas.',
  'onboarding.email.smtpLegend': 'SMTP — envío de correos',
  'onboarding.email.smtpHint': 'Servidor SMTP para enviar invitaciones y notificaciones.',
  'onboarding.email.saveImap': 'Guardar y probar IMAP',
  'onboarding.email.imapSaved': 'IMAP guardado.',
  'onboarding.email.saveSmtp': 'Guardar SMTP',
  'onboarding.email.smtpSaved': 'SMTP guardado.',
  'onboarding.email.testSmtp': 'Probar conexión SMTP',
  'onboarding.email.testOk': 'Prueba de conexión: {message}',
  'onboarding.email.testFail': 'Fallo en la prueba: {error}',
  'onboarding.email.tip.host': 'Dirección del servidor de correo (ej.: imap.ejemplo.com o smtp.ejemplo.com).',
  'onboarding.email.tip.password': 'Contraseña o contraseña de aplicación del buzón. Se guarda cifrada.',
  'onboarding.email.tip.testSmtp': 'Guarde el SMTP antes de probar — la prueba usa la configuración ya persistida.',
  'onboarding.municipios.title': 'Municipios monitorizados',
  'onboarding.municipios.subtitle': 'Seleccione en el catálogo los municipios de los que su organización recibe NFS-e.',
  'onboarding.municipios.searchPlaceholder': 'Buscar municipio por nombre...',
  'onboarding.municipios.search': 'Buscar',
  'onboarding.municipios.searching': 'Buscando...',
  'onboarding.municipios.empty': 'Ningún municipio encontrado en el catálogo.',
  'onboarding.municipios.selected': 'Seleccionado',
  'onboarding.municipios.add': 'Añadir',
  'onboarding.municipios.remove': 'Quitar',
  'onboarding.municipios.count': '{count} municipio(s) seleccionado(s).',
  'onboarding.municipios.save': 'Guardar selección',
  'onboarding.municipios.update': 'Actualizar selección',
  'onboarding.municipios.saved': 'Selección guardada ({count} municipios).',
  'onboarding.thresholds.title': 'Umbrales de validación',
  'onboarding.thresholds.subtitle': 'Confianza mínima del VLM, auto-aprobación y cola de revisión — valores por defecto ya completados.',
  'onboarding.thresholds.save': 'Guardar umbrales',
  'onboarding.thresholds.saved': 'Umbrales guardados.',
  'onboarding.tour.title': 'Tour guiado por la interfaz',
  'onboarding.tour.subtitle': 'Un recorrido interactivo por las principales áreas del sistema.',
  'onboarding.tour.start': 'Iniciar tour',
  'onboarding.tour.next': 'Siguiente',
  'onboarding.tour.prev': 'Anterior',
  'onboarding.tour.skip': 'Saltar tour',
  'onboarding.tour.finish': 'Concluir',
  'onboarding.tour.counter': '{current}/{total}',
  'onboarding.tour.step.intro.title': 'Bienvenido a Aura Nota',
  'onboarding.tour.step.intro.body': 'Este tour rápido muestra dónde están las principales áreas: carga, documentos, catálogo y configuración.',
  'onboarding.tour.step.upload.title': 'Carga de documentos',
  'onboarding.tour.step.upload.body': 'Envíe PDFs, XMLs e imágenes de NFS-e y facturas aquí — la extracción es automática.',
  'onboarding.tour.step.documents.title': 'Documentos',
  'onboarding.tour.step.documents.body': 'Todos los documentos capturados están aquí, con estado de extracción y revisión.',
  'onboarding.tour.step.catalogo.title': 'Catálogo de municipios',
  'onboarding.tour.step.catalogo.body': 'Consulte la cobertura municipio → proveedor NFS-e y sugiera nuevos mapeos.',
  'onboarding.tour.step.settings.title': 'Configuración del tenant',
  'onboarding.tour.step.settings.body': 'Gestione usuarios, proveedores, correo, retención y umbrales de la organización.',
  'onboarding.tour.step.done.title': 'Tour concluido',
  'onboarding.tour.step.done.body': '¡Listo! Complete la etapa para finalizar el checklist de onboarding.',
  'onboarding.done.title': '¡Onboarding concluido!',
  'onboarding.done.body': 'La organización está configurada y lista para capturar documentos.',
  'onboarding.done.notified': '{count} socio(s) notificado(s) de la conclusión.',
  'onboarding.done.goUpload': 'Enviar primer documento',
  'onboarding.done.goSettings': 'Abrir configuración',
};
